import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.authService.isSignedIn()) {
      return true;
    } else {
      return this.authService.refreshToken().pipe(
        map(result => {
          return true;
        }),
        catchError(error => {
          return of(this.router.createUrlTree(['/signin'], {
            queryParams: { returnUrl: state.url }
          }));
        })
      );
    }
  }
}

